import { Injectable } from '@angular/core';
import { APIHandler } from '../api-handler/api-handler';
import { ConfigurationService } from 'src/app/modules/configuration/services/configuration/configuration.service';
import {
  SelfSelectedAssignmentData,
  SelfSelectedAssignmentDataResponse,
  UpdateAssignmentData,
  UpdatedAssignmentDataResponse,
} from '../../types';
import { MessageService } from 'src/app/modules/message/services/message/message.service';
import { LoggingService } from 'src/app/shared/services/logging/logging.service';

@Injectable()
export class AssignmentAPI {
  readonly pathBase = `api/v1/assignment`;
  authToken = '';
  private apiHandler: APIHandler;

  constructor(
    private configService: ConfigurationService,
    private messageService: MessageService,
    private loggingService: LoggingService
  ) {
    this.apiHandler = new APIHandler(
      {
        baseUrl: this.configService.config.contentMetadataDomain,
        defaultHeaders: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      },
      this.configService.config.configId
    );
  }

  async createNewRecord(
    record: SelfSelectedAssignmentData[]
  ): Promise<string | number | undefined> {
    try {
      const response = (await this.apiHandler.post(this.pathBase, {
        data: record,
      })) as unknown as SelfSelectedAssignmentDataResponse;

      if (!response || response.data.length === 0) {
        throw response;
      }
      const responseID = response.data[0].data.key;
      console.log('Return the ID from the response', response);
      return responseID;
    } catch (e) {
      console.error(e);
      return undefined;
    }
  }

  async updateRecord(
    record: UpdateAssignmentData[]
  ): Promise<UpdatedAssignmentDataResponse | undefined> {
    try {
      const res = (await this.apiHandler.patch(this.pathBase, {
        data: record,
      })) as unknown as UpdatedAssignmentDataResponse;
      if (!res || !res.data) {
        throw res;
      }
      console.log('Updated an assignment data', res);
      return res;
    } catch (e) {
      console.error(e);
      throw e;
    }
  }

  setAuthToken(authToken: string): void {
    this.authToken = authToken;
    this.configureHandler();
  }

  configureHandler(): void {
    this.apiHandler.configure({
      baseUrl: this.configService.config.contentMetadataDomain,
      defaultHeaders: {
        Authorization: 'Bearer ' + this.authToken,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    });
    this.apiHandler.messageService = this.messageService;
    this.apiHandler.loggingService = this.loggingService;
  }
}
